/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptiontranslating2Inputs */

const en_eventdescriptiontranslating2 = /** @type {(inputs: Eventdescriptiontranslating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translating`)
};

const de_eventdescriptiontranslating2 = /** @type {(inputs: Eventdescriptiontranslating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird übersetzt`)
};

/**
* | output |
* | --- |
* | "Translating" |
*
* @param {Eventdescriptiontranslating2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptiontranslating2 = /** @type {((inputs?: Eventdescriptiontranslating2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptiontranslating2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptiontranslating2(inputs)
	return de_eventdescriptiontranslating2(inputs)
});
export { eventdescriptiontranslating2 as "eventDescriptionTranslating" }